<!-- 疗效判定和疗效跟踪弹窗 -->
<template>
  <div>
    <a-modal v-model:visible="visible" :title="title" centered @cancel="onCancel">
      <div class="step-title" v-if="modelMode === 3">
        <a-steps :current="current">
          <a-step v-for="item in steps" :key="item.title" :title="item.title" />
        </a-steps>
      </div>

      <div class="steps-content" v-if="current === 0">
        <!-- 疗效跟踪 -->
        <VisitEffect :visitInfo="visitInfo" @followResultChange="followResultChange" />
      </div>
      <div class="steps-content" v-if="current === 1">
        <!-- 疗效判定 -->
        <PrescriptEffect
          :prescriptInfo="prescriptInfo"
          @prescriptResultChange="prescriptResultChange"
          @cancel="onCancel"
        />
      </div>
      <template #footer>
        <a-button
          v-for="(item, index) in stepBuss[current]"
          :type="item.type"
          :key="index"
          @click="item.cb"
          :disabled="item.disabled"
        >
          {{ item.label }}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script setup>
import VisitEffect from './visitEffect.vue'
import PrescriptEffect from './prescriptEffect.vue'
import { prescriAssertCure, determineEffectByfollID } from '@/api/workPlace/prescription'
import { ref, defineExpose, reactive, defineEmits } from 'vue'
import { updataPlanFlow, getFollowUpPlanFlowDTOById } from '@/api/workPlace/visits.js'

import moment from 'moment'

const emits = defineEmits(['completeBuss'])
const visible = ref(false)
const current = ref(0)
const modelMode = ref(0) // 1:弹处方判断 2：弹疗效跟踪  3：弹处方判断+疗效跟踪
const title = ref('填写疗效跟踪')
const visitInfo = ref({})
const prescriptInfo = ref({})
const steps = [
  {
    title: '疗效跟踪',
    content: ''
  },
  {
    title: '疗效判定',
    content: ''
  }
]
const stepBuss = reactive([
  [
    {
      label: '取消',
      type: 'default',
      cb: onCancel
    },
    {
      label: '下一步',
      type: 'primary',
      cb: determineVisit,
      disabled: true
    }
  ],
  [
    {
      label: '取消',
      type: 'default',
      cb: onCancel
    },
    {
      label: '确定',
      type: 'primary',
      cb: determinePrescript,
      disabled: true
    }
  ]
])
function determineVisit() {
  // 提交疗效跟踪结果
  const { id, flowTime, flowResultStatus, stageName } = visitInfo.value
  const reg = /第(.*)次疗效跟踪/
  const res = reg.exec(stageName)
  const flowNum = res ? res[1] : null
  const params = {
    flowId: id,
    flowTime: moment(flowTime).format('YYYY-MM-DD') + ' ' + '10:00:00',
    flowResultStatus,
    i: flowNum
  }
  updataPlanFlow(params).then(() => {
    if (modelMode.value === 3) {
      current.value = current.value + 1
      title.value = '判定疗效'
    } else {
      visible.value = false
      emits('completeBuss')
    }
  })
}
function determinePrescript() {
  // 提交疗效判定结果
  const {
    determineResult,
    operationType,
    serialNumber = null,
    originalSource,
    operationSource,
    followupPlanId
  } = prescriptInfo.value

  let params = {}
  let FN = null
  if (operationSource === 2) {
    params = {
      determineResult,
      originalSource, //判定来源：1-系统判定 2-系统非续方 3-BD工单 4-BD其他 5-健管工单 6-健管其他
      followupPlanId
    }
    FN = determineEffectByfollID
  } else {
    params = {
      determineResult,
      operationType,
      serialNumber,
      originalSource, //判定来源：1-系统判定 2-系统非续方 3-BD工单 4-BD其他 5-健管工单 6-健管其他
      followupPlanId
    }
    FN = prescriAssertCure
  }
  FN(params)
    .then(() => {
      visible.value = false
      emits('completeBuss')
    })
    .catch(() => {})
}
function onCancel() {
  current.value = null
  visible.value = false
  stepBuss[0][1].disabled = true
  stepBuss[1][1].disabled = true
}
function followResultChange(val) {
  visitInfo.value.flowResultStatus = val
  stepBuss[current.value][1].disabled = false
}
function prescriptResultChange(val) {
  prescriptInfo.value.determineResult = val
  stepBuss[current.value][1].disabled = false
}
function getFollowUpPlanFlowDTOByIdFn(followUpPlanFlowId) {
  return new Promise((resolve, reject) => {
    if (followUpPlanFlowId) {
      getFollowUpPlanFlowDTOById({ followUpPlanFlowId })
        .then(res => {
          resolve(res)
        })
        .catch(() => {
          reject()
        })
    } else {
      reject()
    }
  })
}
const initModal = async (params = {}) => {
  const { mode, visitInfo: vsInfo = {}, prescriptInfo: preInfo = {} } = params
  prescriptInfo.value = preInfo
  try {
    const res = await getFollowUpPlanFlowDTOByIdFn(vsInfo.followUpPlanFlowId)
    visitInfo.value = res
  } catch {
    visitInfo.value = {}
  }
  const val = prescriptInfo.value.effectivenessResult
  switch (mode) {
    case 2:
      title.value = '填写疗效跟踪'
      current.value = 0
      stepBuss[current.value][1].label = '确定'
      break
    case 1:
      title.value = '判定疗效'
      current.value = 1
      if (val) {
        prescriptResultChange(val)
      }
      break
    default:
      title.value = '填写疗效跟踪'
      current.value = 0
      break
  }
  modelMode.value = mode || 0
  visible.value = true
}
defineExpose({ initModal })
</script>
<style scoped lang="scss">
.step-title {
  margin-bottom: 20px;
}
</style>
